import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Login from '@/views/LogIn.vue';
import ManufacturingItems from '@/views/ManufacturingItems.vue';
import Station from '@/views/Station.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/locales',
      name: 'Locales',
      component: () => import(/* webpackChunkName: "locales" */ '@/views/Locales.vue'),
    },
    {
      path: '/login',
      name: 'Log In',
      component: Login,
    },
    {
      path: '/manufacturers',
      name: 'Manufacturers',
      component: () => import(/* webpackChunkName: "manufacturers" */ '@/views/Manufacturers.vue'),
    },
    {
      path: '/manufacturing-items',
      name: 'Manufacturing Items',
      component: ManufacturingItems,
    },
    {
      path: '/set-elements',
      name: 'Set Elements',
      component: () => import(/* webpackChunkName: "setElements" */ '@/views/SetElements.vue'),
    },
    {
      path: '/stations/:station',
      name: 'Station',
      component: Station,
    },
    {
      path: '/statuses',
      name: 'Statuses',
      component: () => import(/* webpackChunkName: "statuses" */ '@/views/Statuses.vue'),
    },
    {
      path: '/users',
      name: 'Users',
      component: () => import(/* webpackChunkName: "users" */ '@/views/Users.vue'),
    },
  ],
});
